// src/components/admin/menu/AdminMenuManager.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import fetchData from '../../../api/fetchData'; 
import { useTranslation } from 'react-i18next';


function AdminMenuManager( {onContentUpdated} ) {
const { t } = useTranslation();
const navigate = useNavigate();

const [menuItems, setMenuItems] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);


    const loadMenuItems = async () => {
        setLoading(true);
        setError(null);
        try {
          const response = await fetchData('/admin/menu/admin_get_all_menu_items.php', 'GET', null, { credentials: 'include' });
            if (response && response.status === 'success') {
                setMenuItems(response.items || []);
            } else {
                setError(response?.message || 'Не удалось загрузить пункты меню.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
    loadMenuItems();
}, []);

const handleAddNewMenuItem = () => {
    navigate('/admin/menu/add');
};

const handleDeleteMenuItem = async (menuItemId, menuItemTitle) => {
    const confirmationMessage = t('admin.menu.deleteConfirmation', { title: menuItemTitle, id: menuItemId });
    if (window.confirm(confirmationMessage)) {
      try {
        const response = await fetchData(
          '/admin/menu/admin_delete_menu_item.php', 
          'POST', 
          { menuItemId: menuItemId }, 
          { credentials: 'include' }
        );
        if (response && response.status === 'success') {
          alert(response.message); 
          loadMenuItems(); 

          if (onContentUpdated) {
            onContentUpdated();
          }

        } else {
          alert(t('admin.menu.deleteError', { details: response?.message || 'Unknown error' }));
        }
      } catch (err) {
        alert(t('messages.error.generic', { details: err.message }));
      }
    }
  };

 if (loading) return <p>{t('messages.loading', 'Загрузка...')}</p>;
 if (error) return <p>{t('messages.error.generic', { details: error })}</p>;
 

 return (
    <div className="admin-menu-manager">
        <h4>{t('admin.menu.managerTitle', 'Управление Пунктами Меню')}</h4>

<button onClick={handleAddNewMenuItem} style={{ marginBottom: '20px' }}>
    {t('admin.menu.addNewButton', 'Добавить новый пункт меню')}
</button>

{menuItems.length === 0 ? (
    <p>{t('admin.menu.noItems', 'Пунктов меню пока нет.')}</p>
) : ( 
    <table>
        <thead>
            <tr>
             <th>{t('admin.menu.idLabel', 'ID')}</th>
              <th>{t('admin.menu.titleLabel', 'Название (RU)')}</th>
              <th>{t('admin.menu.linkLabel', 'Ссылка (URL)')}</th>
              <th>{t('admin.menu.actionsLabel', 'Действия')}</th>
            </tr>
        </thead>
        <tbody>
            {menuItems.map(item => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.menu_title}</td>
                    <td>{item.menu_link}</td>
                    <td>
                    <Link to={`/admin/menu/edit/${item.id}`}>
                    {t('admin.buttons.edit', 'Редактировать')}
                    </Link>
                    <button 
                    onClick={() => handleDeleteMenuItem(item.id, item.menu_title)} 
                    className="delete-button"
                  >
                    {t('admin.buttons.delete', 'Удалить')} 
                  </button>
                    </td>
                </tr>
            ))}
        </tbody>
    </table>
)}

    </div>
 );
}

export default AdminMenuManager;